import debounce from 'lodash/debounce';
import { history } from '../Store';
import Axios from 'axios';
import CONFIG from '../config'
    
const eventLog = async (eventType, data) => {
    if(eventType==="MODULE_TIME_TRACK"){
        const username   = localStorage.getItem('currentUser');
        if(username){
            const request = {
                user: username,
                event: eventType,
                data,
                sessionID: sessionStorage.getItem('SESSION_BASE_KEY') || null
            }
            const response = await Axios.post(CONFIG.apiURL + `/log`,request);
            return response.data;
        }
        return {};
    }else{
        // console.log('Not a module Time Track')
    }
};

const trackModuleTime = (data) => {
    eventLog("MODULE_TIME_TRACK", data);
};


const trackPages = () => {
    let pageTrack = (location) => {
        let data = {
            url: location ? location.pathname : window.location.pathname + window.location.search 
        }
        eventLog("PAGE_NAVIGATION", data);
    };
    pageTrack();
    history.listen(debounce(pageTrack, 1000));
};

const initSession = async () => {
        // const response = await eventLog("INIT_SESSION", {});
        // sessionStorage.setItem('SESSION_BASE_KEY', response.sessionID);
        // sessionStorage.setItem('PAGE_HIDDEN_DURATION', 0);
};


const unloadSession = () => {
    let pageHiddenDuration = sessionStorage.getItem('PAGE_HIDDEN_DURATION');
    let timeSincePageLoad = Math.abs(Math.round(performance.now()) - pageHiddenDuration);
    eventLog("TERMINATE_SESSION", {
        timeSincePageLoad: Math.floor(timeSincePageLoad / 1000 )
    })
};

const endSession = () => {
    window.addEventListener('beforeunload', unloadSession);
};

const visibilityState = () => {
    document.addEventListener('visibilitychange', () => {
        let prevHiddenAt = sessionStorage.getItem('pageHiddenAt');
        if(document.hidden) {
            sessionStorage.setItem('pageHiddenAt', Date.now());
        }
        else if(prevHiddenAt){
            let pageVisibleAt = Date.now();
            let pageHiddenFor = pageVisibleAt - prevHiddenAt;
            let prevHiddenDuration = +sessionStorage.getItem('PAGE_HIDDEN_DURATION');

            pageHiddenFor = pageHiddenFor + prevHiddenDuration;
            sessionStorage.setItem('PAGE_HIDDEN_DURATION', pageHiddenFor);
        }
    })
}

const sessionHandler = () => {
    const username  = localStorage.getItem('currentUser');
    if(username){
        window.addEventListener('load', initSession);
        initSession();
        endSession();
        visibilityState();
    }
};

const navigator = {
    trackPages,
    sessionHandler,
    trackModuleTime,
    unloadSession
};

export default navigator;